'use strict';

var GridExportController = function GridExportController($scope, fileSaveService, columnNameTransformationService) {
  function exportData(gridSettings) {
    var columnsToHide = columnNameTransformationService.getColumnsToHide(gridSettings);
    columnNameTransformationService.hideColumns(gridSettings, columnsToHide);
    var data = gridSettings.apply('exportdata', 'xls');
    columnNameTransformationService.unhideColumns(gridSettings, columnsToHide);
    return data;
  }
  $scope.exportToExcel = function (gridId) {
    var fileType = 'application/vnd.ms-excel;charset=UTF-8';

    //parse print xml to suffix excluded columngroup names onto column names
    var data = exportData($scope.gridSettings);
    data = columnNameTransformationService.flattenColumnNames(data, $scope.gridSettings, 'xls');
    if ($scope.postExportDataTransformer) {
      data = $scope.postExportDataTransformer(data);
    }

    // Notice: if we use .xls extension here, Excel will complain about compatibility problems.
    // On the other hand, the .xml extension might be too generic.
    var fileExtension = 'xml';
    var fileName = fileSaveService.createFileName(gridId, fileExtension);
    fileSaveService.createFile(data, fileType, fileName);
  };
};
GridExportController.$inject = ['$scope', 'FileSaveService', 'ColumnNameTransformationService'];
module.exports = GridExportController;